import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import GlassButton from '../ui/GlassButton';

export default function FinalCTA() {
    const navigate = useNavigate();

    return (
        <section className="py-32 relative px-6">
            <div className="max-w-5xl mx-auto">
                <motion.div
                    initial={{ opacity: 0, scale: 0.95 }}
                    whileInView={{ opacity: 1, scale: 1 }}
                    viewport={{ once: true }}
                    className="bg-white/[0.03] backdrop-blur-xl border border-white/[0.08] rounded-3xl p-12 md:p-24 text-center relative overflow-hidden"
                >
                    {/* Decorative Glow */}
                    <div className="absolute top-0 right-0 w-[300px] h-[300px] bg-blue-500/[0.1] blur-[100px] pointer-events-none" />
                    <div className="absolute bottom-0 left-0 w-[300px] h-[300px] bg-purple-500/[0.1] blur-[100px] pointer-events-none" />

                    <div className="relative z-10">
                        <h2 className="text-4xl md:text-5xl font-bold mb-8">
                            Ready to Ace Your <br />
                            <span className="text-gradient">Next Interview?</span>
                        </h2>
                        <p className="text-zinc-300 text-lg mb-12 max-w-2xl mx-auto">
                            Join thousands of professionals who have improved their interview skills and landed their dream jobs with PitchMe.AI.
                        </p>

                        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
                            <GlassButton
                                variant="primary"
                                size="lg"
                                onClick={() => navigate('/login')}
                                icon={<i className="ri-rocket-line"></i>}
                            >
                                Start Your Free Trial
                            </GlassButton>
                            <GlassButton
                                variant="outline"
                                size="lg"
                                onClick={() => navigate('/contact')}
                            >
                                Talk to Sales
                            </GlassButton>
                        </div>
                    </div>
                </motion.div>
            </div>
        </section>
    );
}
